module.exports = __webpack_public_path__ + "img/组 362 拷贝 3(2).8dadd88c.png";